// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__bID-s","appName":"Header_appName__PHhU-","logo":"Header_logo__knm-M","actions":"Header_actions__Lif3q"};